import type { VFC } from 'react';

import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';

import { formatDurationFromSeconds } from '../../utils/datetime';
import { usePlayerChapters } from '../Player/usePlayerChapters';
import type { Unpacked } from '../../utils/types';

import { Chapter } from './Chapter/Chapter';

import * as styles from './ChaptersList.module.scss';

function getLabel(
  chapter: Unpacked<SvpAssetAdditional['additional']['chapters']>
) {
  const time = formatDurationFromSeconds(chapter.timeline, true);

  return `${time} - ${chapter.title}`;
}

export interface ChaptersListProps {
  chapters: SvpAssetAdditional['additional']['chapters'];
}

const ChaptersList: VFC<ChaptersListProps> = ({ chapters }) => {
  const { activeChapterIndex, seekToChapter } = usePlayerChapters(chapters);

  return (
    <div className={styles.chaptersList}>
      {chapters.map((chapter, index) => (
        <Chapter
          key={chapter.timeline}
          className={styles.chapter}
          onClick={() => seekToChapter(chapter)}
          active={activeChapterIndex === index}
        >
          {getLabel(chapter)}
        </Chapter>
      ))}
    </div>
  );
};

export { ChaptersList };
